<div class="tag-details-view-container" *ngIf="dynamicDictionaryObject" fxLayout="column" fxLayoutGap="15px" >
  <div fxLayout="row" fxLayoutGap="15px">
    <button [disabled]="!(userPermissions | async).dynamic_dictionary.write " (click)="modify()" mat-stroked-button color="primary"><mat-icon>create</mat-icon> <span> Edytuj</span></button>
    <button [disabled]="!((userPermissions | async)?.dynamic_dictionary.write)"
            (click)="delete()" mat-stroked-button color="warn">
      <mat-icon>delete</mat-icon> <span> Usuń</span>
    </button>
  </div>
  <div fxLayout="row" fxLayoutGap="15px" fxFlex="100" fxLayout.lt-lg="column">
    <div fxLayout="column" fxFlex="100" fxFlex.lt-md="100" fxLayoutGap="15px">

    <mat-card>

        <div fxLayout="row">
          <h3>Dane</h3>
        </div>

        <div fxLayout="row" fxLayoutGap="15px">
          <div fxFlex="100" >
            <app-detail  header="Nazwa " [value]="dynamicDictionaryObject.name"></app-detail>
          </div>
        </div>

        <div fxLayout="row" fxLayoutGap="15px">
          <div fxFlex="100" >
            <app-detail  header=" Typ " [value]="dynamicDictionaryObject.type?.name"></app-detail>
          </div>
        </div>

      </mat-card>
    </div>
  </div>
</div>
